/**
 * Recursively checks the validity of keys in a JSON object.
 *
 * @param {Object} obj - The JSON object to check.
 * @throws {string} Throws an error message if keys are invalid (start with a number or contain invalid characters).
 */
export const checkKeysValidity = async (obj) => {
  // Check if the input is an object and not null
  if (typeof obj === "object" && obj !== null) {
    // Define a regular expression pattern for valid keys
    const pattern = /^[A-Za-z\d-\s()+₹.@$%&*]*$/

    // Iterate through each key in the object
    for (const key in obj) {
      // Check if the key is an own property of the object
      if (obj.hasOwnProperty(key)) {
        // Check if the key starts with a number
        if (/^[0-9]/.test(key)) {
          // Throw an error if the key starts with a number
          throw `JSON Editor Key <strong>${key}</strong> starts with a Number (Numbers at the leading place are not allowed).`
        }

        // Check if the key contains invalid characters
        if (!pattern.test(key)) {
          // Throw an error if the key contains invalid characters
          throw `JSON Editor Key <strong>${key}</strong> contains invalid characters (Allowed special characters: <strong>-()+₹.@$%&*</strong>).`
        }

        // Recursively process nested objects
        if (typeof obj[key] === "object") {
          await checkKeysValidity(obj[key])
        }
      }
    }
  }
}
